var cov_bn2i7x8xf = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Menu/index.ts",
      hash = "3dc18e425389c22ca2755bfe10a5ba344c2a0cb6",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Menu/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 0
        },
        end: {
          line: 3,
          column: 33
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import Root from './Root';
cov_bn2i7x8xf.s[0]++;
Root.displayName = 'ShineoutMenu';
export default Root;